// extracted by mini-css-extract-plugin
export var hamburger = "styles-module--hamburger--797ec";
export var headerForDoc = "styles-module--headerForDoc--9ee74";